import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useSeriesQuery = createQueryHook(MembershipsCreatorV2ApiClient.getSeries, {
  queryKey: ['series'],
})
